
import { defineComponent } from 'vue'
import InterOral from '@/components/en/presentation/InterOral.vue'
import InterPoster from '@/components/en/presentation/InterPoster.vue'
import ExtSeminar from '@/components/en/presentation/ExtSeminar.vue'

export default defineComponent({
  name: 'PresentationEn',
  components: {
    InterOral,
    InterPoster,
    ExtSeminar
  },
  emits: [
    'Activate'
  ],
  mounted () {
    console.log('mounted')
    this.$emit('Activate', this.activate())
  },
  methods: {
    activate () {
      return 'presentation'
    }
  }
})
